import { Button } from '@chakra-ui/react';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import {
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerBody,
  ModalOrDrawerCloseButton,
  ModalOrDrawerFooter,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@ui/components/ModalOrDrawer';
import { useTranslations } from '@ui/i18n';
import type { FC } from 'react';

import { DateRangeIndicator } from './DateRangeIndicator';
import { DateRangePicker } from './DateRangePicker';
import { useDateRangePickerModal } from './useDateRangePickerModal';

export const DateRangePickerModal: FC = () => {
  const t = useTranslations();

  const isOpen = useDateRangePickerModal((s) => s.isOpen);
  const onClose = useDateRangePickerModal((s) => s.onClose);
  const onConfirm = useDateRangePickerModal((s) => s.onConfirm);
  const selectedDate = useDateRangePickerModal((s) => s.selectedDate);
  const dateForInitialView = useDateRangePickerModal(
    (s) => s.dateForInitialView,
  );
  const isValidSelectedDate =
    selectedDate.length >= 2 && selectedDate.every((v) => v);

  return (
    <ModalOrDrawer
      isOpen={isOpen}
      onClose={onClose}
      placement="bottom"
      size={{
        base: 'full',
        desktop: 'md',
      }}
    >
      <ModalOrDrawerOverlay />
      <ModalOrDragDrawerContent>
        <InDesktop>
          <ModalOrDrawerCloseButton />
        </InDesktop>
        <ModalOrDrawerHeader>{t('Select dates')}</ModalOrDrawerHeader>
        <ModalOrDrawerBody py="0" px="0">
          <DateRangePicker
            minH="435px"
            dateForInitialView={dateForInitialView}
            selectedDate={selectedDate}
            onDateSelected={(selectedDate) => {
              useDateRangePickerModal.setState({
                selectedDate,
              });
            }}
          />
        </ModalOrDrawerBody>
        <ModalOrDrawerFooter>
          <DateRangeIndicator
            selectedDate={selectedDate}
            justifyContent="center"
          />
          <Button
            disabled={!isValidSelectedDate}
            onClick={() => {
              onConfirm(selectedDate);
              onClose();
            }}
          >
            {t('Done')}
          </Button>
        </ModalOrDrawerFooter>
      </ModalOrDragDrawerContent>
    </ModalOrDrawer>
  );
};
